<template>
  <div>
    <info-text i18n="integrations.helper.sso_connection.introduction.create" />
    <va-create-layout>
      <sso-connections-form :item="item" />
    </va-create-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";

export default {
  components: { InfoText },
  props: ["title", "item"]
};
</script>
